module.exports = __webpack_public_path__ + "static/img/large-scale.85b9184.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/home/large-scale.png
// module id = UcPm
// module chunks = 12